module.exports = __webpack_public_path__ + "img/YD.0813f666.png";